import styled from 'styled-components';
import { THEME } from '../../../../../themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.TINO};
`;

export const WidgetDivider = styled.div<{ isBig?: boolean }>`
  width: 1px;
  height: ${({ isBig }) => isBig ? 83 : 64}px;
  background-color: ${THEME.COLORS.PRIMARY_DARK};
  opacity: ${THEME.OPACITY.GHOST};
  margin: 0 ${THEME.SPACING.BASE};
`;

export const ByeBiasWidgetContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${THEME.SPACING.TINY};
  position: relative;
  z-index: 2200;
  
  button {
    font-size: 11px;
    padding: 4px 8px;
    border-color: ${THEME.COLORS.CONTENT_A};
    color: ${THEME.COLORS.CONTENT_A};
    opacity: 0.6;
  }
`;
